import * as zonesetting from './action-type';

// 设置 区域参数信息 数据
export const setZoneData = data => {
    return {
        type: zonesetting.ZONESETTING,
        data,
    };
};
export const updateSelectCard = selectCard => {
    return {
        type: zonesetting.UPDATESELECTCARD,
        selectCard: selectCard,
    };
};
//更新areaList init：是否为初始化，第一次进页面时传
export const updateAreaList = (areaList, init = false, callBack) => {

    if (callBack) {callBack(areaList);}

    return {
        type: zonesetting.UPDATEAREALIST,
        areaList: areaList,
        init,
    };
};

//当前选中区域
export const updateSelectArea = selectedArea => {
    return {
        type: zonesetting.UPDATESELECTAREA,
        selectedArea: selectedArea,
    };
};

export const updatePreviewData = previewData => {
    return {
        type: zonesetting.PREVIEWDATA,
        previewData: previewData,
    };
};
// 清空数据
export const clearData = () => {
    return { type: zonesetting.CLEARDATA };
};

//打开公式编辑器
export const toggleFormula = (type, data) => {
    return {
        type: zonesetting.TOGGLEFORMULA,
        formula: { [type]: data || { visible: false, value: "" } },
    };
};

//设置公式编辑器信息
export const setFormulaInfo = formulaInfo => {
    return {
        type: zonesetting.SETFORMULAINFO,
        formulaInfo,
    };
};

//设置批量设置表格dataSource
export const updateBatchSource = batchSource => {
    return {
        type: zonesetting.UPDATEBATCHSOURCE,
        batchSource,
    };
};
//更新批量设置表格dataSource
export const setCurrentBatchCell = cell => {
    return {
        type: zonesetting.SETCURRENTBATCHCELL,
        currentBatchCell: cell,
    };
};
// 传递 区域 form 的区域值
export const setZoneDataFun = getFromData => {
    return {
        type: zonesetting.SETZONEFORMFUN,
        getFromData,
    };
};

//更新是否保存标示
export const updateSaveFlag = flag => {
    return {
        type: zonesetting.UPDATESAVEFLAG,
        isSave: flag,
    };
};

//更新是否校验成功标示
export const updateAreaValidate = validate => {
    return {
        type: zonesetting.SETAREAVALIDATE,
        validate,
    };
};

//更新是否模板是否实施态标示
export const setImplementFlag = flag => {
    return {
        type: zonesetting.SETIMPLEMENTFLAG,
        isImplement: flag,
    };
};

// 更新 区域 隐藏不显示属性

export const setAreaItemVisible = data => {
    return {
        type: zonesetting.SETAREAVISIBLE,
        areaVisible: data,
    };
};
//标签布局模态框是否弹出
export const setTabLayModalVisible = visible => {
    return {
        type: zonesetting.TABLAYMODALVISIBLE,
        showTabLaySetModal: visible,
    };
};

// 初始化 和 保存时才更新数据

export const setServerData = data => {
    return {
        type: zonesetting.SETSEVERDATA,
        serverData: data,
    };
};

// 更新 区域 隐藏不显示属性

export const setAreaHide = data => {
    return {
        type: zonesetting.SETAREAHIDE,
        areaHide: data,
    };
};

// 设置选中的树节点
export const setMetaTreeNodes = data => {
    return {
        type: zonesetting.SET_META_TREE_NODES,
        data,
    };
};

// 更新searchbox 状态
export const updateSearchBox = data => {
    return {
        type: zonesetting.UPDATE_SEARCH_BOX,
        boxStatus: data,
    };
};

//切换左栏显隐
export const onToggleLeftSider = flag => {
    return {
        type: zonesetting.ONTOGGLELEFTSIDER,
        leftSiderShow: flag,
    };
};

//更新是否模板是移动模板标示
export const setMobileFlag = ismobile => {
    return {
        type: zonesetting.SETMOBILEFLAG,
        ismobile,
    };
};

//更新是否报表模板标示
export const setReportFlag = isreport => {
    return {
        type: zonesetting.SETREPORTFLAG,
        isreport,
    };
};